<template>
  <div ref="rootNode" data-component="Me">
    <div>
      <peer-view
        :myScreenShare="false"
        :is-me="true"
        :peer="me"
        :audio-producer-id="audioProducer ? audioProducer.id : null"
        :video-producer-id="videoProducer ? videoProducer.id : null"
        :audio-rtp-parameters="
          audioProducer ? audioProducer.rtpParameters : null
        "
        :video-rtp-parameters="
          videoProducer ? videoProducer.rtpParameters : null
        "
        :audio-track="audioProducer ? audioProducer.track : null"
        :video-track="videoProducer ? videoProducer.track : null"
        :video-visible="Boolean(videoProducer) && !videoProducer.paused"
        :audio-codec="audioProducer ? audioProducer.codec : null"
        :video-codec="videoProducer ? videoProducer.codec : null"
        :audio-score="audioProducer ? audioProducer.score : null"
        :video-score="videoProducer ? videoProducer.score : null"
        :face-detection="faceDetection"
        @onChangeDisplayName="changeDisplayName"
        @onChangeMaxSendingSpatialLayer="changeMaxSendingSpatialLayer"
        @onStatsClick="setStatsPeerId"
      />

      <!-- :piPicture="piPicture" -->
    </div>
  </div>
</template>

<script>
import * as cookiesManager from "../../../utils/cookiesManager";
import PeerView from "../media/PeerView/PeerView";

export default {
  components: { PeerView },
  props: {
    roomClient: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      //piPicture:false,
    };
  },
  computed: {
    connected() {
      return this.$store.state.state === "connected";
    },
    me() {
      return this.$store.state.me;
    },
    screenPeer() {
      var consumer = this.$store.state.consumers.find(
        x =>
          x.appData != null &&
          x.appData.share == true &&
          x.appData.source == "screen"
      );

      var meProducer = this.$store.state.producers.find(x => x.type == "share");
      if (meProducer != null) {
        this.myScreenShare = true;
        return this.$store.state.me;
      }

      this.myScreenShare = false;

      if (consumer == null) return null;
      var peer = this.$store.state.peers.find(
        x => x.id == consumer.appData.peerId
      );

      return peer;
    },
    faceDetection() {
      return this.$store.state.faceDetection;
    },
    producers() {
      return this.$store.state.producers;
    },
    audioProducer() {
      return this.producers.find(producer => producer.track.kind === "audio");
    },
    videoProducer() {
      return this.producers.find(
        producer => producer.track.kind === "video" && producer.type !== "share"
      );
    },
    shareProducer() {
      return this.producers.find(producer => producer.type === "share");
    },
    changeWebcamState() {
      if (
        Boolean(this.videoProducer) &&
        this.videoProducer.type !== "share" &&
        this.me.canChangeWebcam
      ) {
        return "on";
      } else {
        return "unsupported";
      }
    },
    shareState() {
      if (this.screenPeer != null) {
        return "on";
      }

      if (Boolean(this.videoProducer) && this.videoProducer.type === "share") {
        return "on";
      } else {
        return "off";
      }
    },
    webcamState() {
      let webcamState;

      if (!this.me.canSendWebcam) {
        webcamState = "unsupported";
      } else if (this.videoProducer && this.videoProducer.type !== "share") {
        webcamState = "on";
      } else {
        webcamState = "off";
      }

      return webcamState;
    },
    micState() {
      let micState;

      if (!this.me.canSendMic) {
        micState = "unsupported";
      } else if (!this.audioProducer) {
        micState = "unsupported";
      } else if (!this.audioProducer.paused) {
        micState = "on";
      } else {
        micState = "off";
      }

      return micState;
    }
  },
  methods: {
    changeDisplayName(name) {
      this.roomClient.changeDisplayName(name);
    },
    changeMaxSendingSpatialLayer(spatialLevel) {
      this.roomClient.setMaxSendingSpatialLayer(spatialLevel);
    },
    setStatsPeerId(peerId) {
      this.$store.commit("RoomsetRoomStatsPeerId", { peerId });
    },
    toggleShare() {
        // var containerId = 'video-' + this.me.id + (this.screenShare ? '-s' : '');
        // var video = document.getElementById(containerId);

      if (this.shareState === "on") {
        this.roomClient.disableShare();

        // try {
        //   if (document.pictureInPictureElement) {
        //      document.exitPictureInPicture();
        //   }
        // } catch (err) {
        //   console.error ("Video failed to leave Picture-in-Picture mode.")
        // }

      } else {
        this.roomClient.enableShare();

        // try {
        //   if (!document.pictureInPictureElement) {
        //      video.requestPictureInPicture();
        //   }
        // } catch (err) {
        //   console.error ("Video failed to enter Picture-in-Picture mode.")
        // }

      }
    },
    changeWebcam() {
      this.$root.$emit("openCameraSettings");
      //this.roomClient.changeWebcam()
    },
    toggleWebcam() {
      if (this.webcamState === "on") {
        cookiesManager.setDevices({ webcamEnabled: false });
        this.roomClient.disableWebcam();
      } else {
        cookiesManager.setDevices({ webcamEnabled: true });
        this.roomClient.enableWebcam();
      }
    },
    toggleMicState() {
      this.micState === "on"
        ? this.roomClient.muteMic()
        : this.roomClient.unmuteMic();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/media/Me.vue